import React from "react";
import * as PropTypes from "prop-types";
import { Checkbox, Tooltip } from "antd";

import UIFormSection from "../FormSection";

import "./index.scss";

const GROUP_ICONS = {
	"afastamentos"              : "fal fa-user-minus",
	"app"                       : "fal fa-mobile-android",
	"banco-de-horas"            : "fal fa-clock",
	"departamentos"             : "fal fa-users",
	"dsr"                       : "fal fa-calendar-star",
	"empresas"                  : "fal fa-building",
	"equipamentos"              : "fal fa-desktop",
	"fechamento-periodo-calculo": "fal fa-calendar-check",
	"feriados"                  : "fal fa-calendar-alt",
	"funcionarios"              : "fal fa-user",
	"funcoes"                   : "fal fa-user-tag",
	"gestao"                    : "fal fa-clipboard-list",
	"horarios"                  : "fal fa-business-time",
	"horas-extras"              : "fal fa-calculator",
	"justificativa-parcial"     : "fal fa-file-alt",
	"justificativas"            : "fal fa-file-signature",
	"lancamentos-coletivos"     : "fal fa-layer-group",
	"log"                       : "fal fa-history",
	"manutencao-banco-horas"    : "fal fa-wrench",
	"perimetro"                 : "fal fa-map-marker-alt",
	"relatorios"                : "fal fa-chart-bar",
	"roles"                     : "fal fa-lock",
	"system-log"                : "fal fa-terminal",
	"users"                     : "fal fa-users-cog",
	"websockets"                : "fal fa-plug",
};

const LOCKED_HINT = "Desmarque as demais permissões deste grupo antes de remover o Listar.";

/**
 * @param {string} key
 *
 * @returns {string}
 */
const groupIcon = (key) => GROUP_ICONS[key] || "fal fa-shield-check";

/**
 * @param {Object} group
 * @param {Object} permission
 * @param {Array} selected
 *
 * @returns {boolean}
 */
const isListLocked = (group, permission, selected) => {
	if( permission.name.toLowerCase() !== "listar" ) return false;

	return group.permissions.some(p => p.uuid !== permission.uuid && selected.indexOf(p.uuid) !== -1);
};

const UIPermissionGroups = ({groups, selected, checkedAll, indeterminate, disabled, onChange, onChangeAll}) => {
	const renderPermission = (group, permission) => {
		const checkbox = (
			<Checkbox
				disabled={disabled}
				checked={selected.indexOf(permission.uuid) !== -1}
				onChange={(e) => onChange(permission.uuid, group.key, e.target.checked)}>
				{permission.name}
			</Checkbox>
		);

		if( disabled || !isListLocked(group, permission, selected) )
		{
			return checkbox;
		}

		return (
			<Tooltip title={LOCKED_HINT}>
				<span className="permission-groups-locked">{checkbox}</span>
			</Tooltip>
		)
	};

	return (
		<div className="permission-groups">
			{groups.map((group, key) => (
				<UIFormSection
					key={key}
					icon={<i className={groupIcon(group.key)} />}
					title={group.name}>
					<div className="permission-groups-options">
						<div className="permission-groups-option">
							<Checkbox
								disabled={disabled}
								indeterminate={indeterminate.indexOf(group.key) !== -1}
								checked={checkedAll.indexOf(group.key) !== -1}
								onChange={(e) => onChangeAll(group.key, e.target.checked)}>
								Controle total
							</Checkbox>
						</div>
						{group.permissions.map((permission, key_p) => (
							<div key={key_p} className="permission-groups-option">
								{renderPermission(group, permission)}
							</div>
						))}
					</div>
				</UIFormSection>
			))}
		</div>
	);
};

UIPermissionGroups.propTypes = {
	groups       : PropTypes.array,
	selected     : PropTypes.array,
	checkedAll   : PropTypes.array,
	indeterminate: PropTypes.array,
	disabled     : PropTypes.bool,
	onChange     : PropTypes.func,
	onChangeAll  : PropTypes.func,
};

UIPermissionGroups.defaultProps = {
	groups       : [],
	selected     : [],
	checkedAll   : [],
	indeterminate: [],
	disabled     : false,
	onChange     : () => null,
	onChangeAll  : () => null,
};

export default UIPermissionGroups;
